module.exports = __webpack_public_path__ + "img/Sun-Heroes-Swag-Graphic.5e139380.png";